export default function CTASection() {
  return (
    <section className="py-24 bg-[#14B8A6] relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-0 w-96 h-96 bg-white rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-white rounded-full blur-3xl"></div>
      </div>
      
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10">
        <h2 className="text-4xl md:text-5xl font-bold text-white mb-6 font-['Playfair_Display']">
          Da el Primer Paso Hacia Tu Bienestar
        </h2>
        <p className="text-xl text-white/95 mb-10 max-w-3xl mx-auto leading-relaxed">
          No tienes que enfrentar tus desafíos solo. Estoy aquí para acompañarte en tu proceso de sanación y crecimiento personal. Agenda tu primera consulta hoy mismo.
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-12">
          <a 
            href="https://wa.me/526692612777?text=Hola%2C%20me%20gustaría%20agendar%20mi%20primera%20consulta" 
            target="_blank" 
            rel="noopener noreferrer"
            className="bg-white text-[#14B8A6] px-8 py-4 rounded-full text-lg font-semibold hover:bg-gray-50 transition-all transform hover:scale-105 shadow-lg whitespace-nowrap cursor-pointer inline-flex items-center gap-2"
          >
            <i className="ri-whatsapp-line text-2xl"></i>
            Contactar por WhatsApp
          </a>
          <a 
            href="#contacto"
            className="bg-transparent text-white px-8 py-4 rounded-full text-lg font-semibold hover:bg-white/10 transition-all border-2 border-white whitespace-nowrap cursor-pointer"
          >
            Enviar Mensaje
          </a>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl mx-auto">
          <div className="text-center">
            <div className="w-16 h-16 flex items-center justify-center bg-white/20 rounded-full mx-auto mb-4">
              <i className="ri-calendar-check-line text-3xl text-white"></i>
            </div>
            <h3 className="text-lg font-semibold text-white mb-2">Horarios Flexibles</h3>
            <p className="text-white/90 text-sm">Sesiones adaptadas a tu disponibilidad</p>
          </div>
          <div className="text-center">
            <div className="w-16 h-16 flex items-center justify-center bg-white/20 rounded-full mx-auto mb-4">
              <i className="ri-video-chat-line text-3xl text-white"></i>
            </div>
            <h3 className="text-lg font-semibold text-white mb-2">Consultas Online</h3>
            <p className="text-white/90 text-sm">Terapia desde la comodidad de tu hogar</p>
          </div>
          <div className="text-center">
            <div className="w-16 h-16 flex items-center justify-center bg-white/20 rounded-full mx-auto mb-4">
              <i className="ri-shield-check-line text-3xl text-white"></i>
            </div>
            <h3 className="text-lg font-semibold text-white mb-2">Confidencialidad</h3>
            <p className="text-white/90 text-sm">Tu privacidad es nuestra prioridad</p>
          </div>
        </div>
      </div>
    </section>
  );
}
